<template>
  <form
    v-bind="$attrs"
    :data-disable-tracking="isDisabledTracking"
    @submit.prevent="onSubmit"
  >
    <slot />
  </form>
</template>

<script setup>
import { z } from "zod";
import { FORM_INJECTION_KEY } from "~/nuxt_modules/common/constants/index.js";

const emits = defineEmits(["submit"]);

/*
state - валидируемая форма;
schema - zod схема валидации;
 */
const props = defineProps({
  state: { type: Object, required: true },
  schema: { type: Object, required: true },
  isDisabledTracking: { type: Boolean, required: false, default: false },
});

const errors = ref({});

const validateField = (fieldName) => {
  const validateResult = props.schema.shape[fieldName].safeParse(
    props.state[fieldName],
  );

  if (!validateResult.success) {
    const flattenError = z.flattenError(validateResult.error);

    errors.value[fieldName] =
      flattenError.fieldErrors[0] ?? flattenError.formErrors;
  } else {
    delete errors.value[fieldName];
  }
};

/*
Передача в инпуты ошибок формы для их вывода и запуск валидации текущего инпута
 */
provide(FORM_INJECTION_KEY, { errors, validateField });

function onSubmit() {
  const { success, data, error } = props.schema.safeParse(props.state);

  if (!success) {
    errors.value = z.flattenError(error).fieldErrors;
  } else {
    emits("submit", data);
  }
}
</script>

<style scoped lang="scss"></style>
